import React, { useEffect, useRef } from "react";

function ChromaKeyVideo({
  src,
  chromaColor = { r: 300, g: 0, b: 0 },
  loop = false,
  onEnded,
  muted = false,
  playing = true,
}) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (playing) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [playing, src]);

  useEffect(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.willReadFrequently = true;

    const handleLoadedData = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const chromaKey = () => {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        try {
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const dataLength = imageData.data.length / 4;

          for (let i = 0; i < dataLength; i++) {
            const offset = i * 4;
            const red = imageData.data[offset];
            const green = imageData.data[offset + 1];
            const blue = imageData.data[offset + 2];

            if (
              Math.abs(red - chromaColor.r) < 100 &&
              Math.abs(green - chromaColor.g) < 100 &&
              Math.abs(blue - chromaColor.b) < 100
            ) {
              imageData.data[offset + 3] = 0;
            }
          }

          ctx.putImageData(imageData, 0, 0);
        } catch (e) {
          console.error("Failed to process the image data:", e);
        }
      };

      const intervalId = setInterval(chromaKey, 40);
      return () => clearInterval(intervalId);
    };

    if (video.readyState >= 3) {
      handleLoadedData();
    } else {
      video.addEventListener("loadeddata", handleLoadedData);
      return () => {
        video.removeEventListener("loadeddata", handleLoadedData);
      };
    }
  }, [chromaColor, src]);

  return (
    <div className="chroma-key-video">
      <video
        ref={videoRef}
        src={src}
        playsInline
        loop={loop}
        onEnded={onEnded}
        style={{ opacity: 0 }}
        crossOrigin="anonymous"
        muted={muted}
      />
      <canvas ref={canvasRef} />
    </div>
  );
}

export default ChromaKeyVideo;
